// External Dependencies
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import styled from 'styled-components';
import type { ReactElement } from 'react';

// Local Typings
interface Props {
  className?: string;
  displayName: string;
  value: ReactElement | number | string | undefined | null;
}

// Local Variables
const StyledRoot = styled.div({
  '.display-name': {
    marginRight: 12,
    whiteSpace: 'nowrap',
  },
  '.display-value': {
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  '.key-value-container': {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    margin: '16px 32px',
  },
});

// Component Definition
const KeyValueDisplay = ({
  className = '',
  displayName,
  value,
}: Props): JSX.Element => {
  return (
    <StyledRoot
      className={
        clsx(
          'key-value-container',
          className,
        )
      }
    >
      <Typography className="display-name">
        {displayName}
      </Typography>
      <Typography className="display-value">
        {value}
      </Typography>
    </StyledRoot>
  );
};

export default KeyValueDisplay;
